import React from 'react';
import "./about.css";
import Footer from '../common/footer/Footer';
import Hero2 from '../common/hero/Hero2';
import Navbar from '../common/navbar/Navbar';
import AboutComponent from './AboutComponent';
const About = () => {
  return (
    <div>
      <Navbar/>
      
      {/* <Hero2 heading="About Me" text="I'm a friendly Front-End Developer"/> */}
      <AboutComponent/>
      <Footer/>
    </div>
  )
}

export default About;